import React from "react";
import { Route, Routes } from "react-router-dom";
import AkfaUnitMappingLayout from "../layout/akfa/AkfaUnitMappingLayout";

function AkfaUnitMappingPage() {
    return (
        <Routes>
            <Route path="/" element={<AkfaUnitMappingLayout />} />
        </Routes>
    );
}

export default AkfaUnitMappingPage;
